import React from 'react'
import TryButton from './TryButtonBrand'
import clsx from 'clsx'
import { useNavigate } from 'react-router-dom'

interface ScanCompletedModalProps {
  hideCondition: boolean
  showCondition: boolean
}

const ScanCompletedModalBrand = (props: ScanCompletedModalProps) => {
  const { hideCondition, showCondition } = props
  const navigate = useNavigate()
  return (
    <div
      className={clsx(
        'absolute bg-scanModalBgDark shadow-hero dark:shadow-unset dark:bg-scanModalBg rounded-5xl top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[336px] flex flex-col items-center gap-6 p-6',
        {
          'opacity-0 pointer-events-none transition-opacity duration-200': hideCondition,
          'opacity-100 transition-opacity duration-200': showCondition,
        },
      )}
    >
      <img src="/video/scan.gif" alt="Scan Completed!" className="max-w-[72px] block" />
      <h3 className="text-center text-XL font-semibold">Scan Completed!</h3>
      <div className="w-full text-lightText flex flex-col gap-2 [&>div]:flex [&>div]:justify-between [&>div>div]:grow [&>div>div]:mx-0.5 [&>div>div]:mb-1 [&>div>div]:border-b-[2px] [&>div>div]:border-dotted [&>div>div]:border-white/50 [&>div>p]:text-logo [&>div>p]:text-center">
        <div>
          <p>Total space to free</p>
          <div></div>
          <p className="dark:text-white font-semibold">54.5 GB</p>
        </div>
        <div>
          <p>Photos ready for removal</p>
          <div></div>
          <p className="blur-[3px] dark:text-white">238</p>
        </div>
        <div>
          <p>Duplicate photos</p>
          <div></div>
          <p className="blur-[3px] dark:text-white">238</p>
        </div>
      </div>
      <TryButton
        text="Continue"
        onClick={() => {
          navigate('/new/email')
        }}
      />
    </div>
  )
}

export default ScanCompletedModalBrand
